import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';

import { useModal } from '@/features/Modals';
import { compareBigNumbers, sumFixedDecimals } from '@/shared/utils/helpers';
/*In case of custom logic made override for WithdrawalInput here*/
import { WithdrawalInput } from '@/widgets/Modals';

type WithdrawalAmountFieldProps = {
    name: string;
};

export const MarginAccountWithdrawalAmountField = ({ name }: WithdrawalAmountFieldProps) => {
    const { control } = useFormContext();
    const { modalProps } = useModal();

    const {
        tokenSymbol,
        decimals,
        interestClaimable,
        totalPosition,
        interestAccrued,
        poolBalance,
    } = modalProps || {};

    const maxBalance = (() => {
        const due = sumFixedDecimals(totalPosition!, interestAccrued!, decimals);
        return compareBigNumbers(due, poolBalance, decimals) === 1 ? poolBalance : due;
    })();

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <WithdrawalInput
                    {...field}
                    setValue={(value) => field.onChange(value)}
                    tokenSymbol={tokenSymbol}
                    poolBalance={poolBalance}
                    decimals={decimals}
                    interestClaimable={interestClaimable}
                    totalPosition={totalPosition}
                    interestAccrued={interestAccrued}
                    disabled={Number(poolBalance) === 0}
                    maxBalance={maxBalance}
                />
            )}
        />
    );
};
